import { useEffect, useState } from 'react';
import { formatMoney } from '@vtf/shared';

export { formatMoney };

export function useNow(ms = 1000) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(t);
  }, [ms]);
  return now;
}

export function fmtTime(d: string | Date | null | undefined, tz: string, withDay = false) {
  if (!d) return '—';
  return new Intl.DateTimeFormat('en-GB', { timeZone: tz, hour: '2-digit', minute: '2-digit', ...(withDay ? { weekday: 'short', day: 'numeric', month: 'short' } : {}) }).format(new Date(d));
}

export function fmtDate(d: string | Date, tz: string) {
  return new Intl.DateTimeFormat('en-GB', { timeZone: tz, weekday: 'long', day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(d));
}

/** "38 min", "1h 12m", "2d 3h" */
export function fmtSpan(ms: number) {
  const m = Math.max(0, Math.round(Math.abs(ms) / 60_000));
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  if (h < 48) return `${h}h ${m % 60}m`;
  return `${Math.floor(h / 24)}d ${h % 24}h`;
}

export function fmtCountdown(target: string | Date, now: number) {
  const diff = new Date(target).getTime() - now;
  return diff >= 0 ? `in ${fmtSpan(diff)}` : `overdue ${fmtSpan(diff)}`;
}

export function fmtClock(seconds: number) {
  const s = Math.max(0, Math.floor(seconds));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

export const fmtR = (r: string | null | undefined) => (r == null ? '—' : `${Number(r) > 0 ? '+' : Number(r) < 0 ? '−' : ''}${Math.abs(Number(r)).toFixed(2)} R`);
export const fmtPct = (v: string | number | null | undefined, d = 2) => (v == null ? '—' : `${Number(v).toFixed(d)} %`);
export const signClass = (v: string | number | null | undefined) => (v == null || Number(v) === 0 ? 'text-sub' : Number(v) > 0 ? 'text-up' : 'text-down');
export const dirLabel = (d: string) => (d === 'LONG' ? '▲ Long' : '▼ Short');
export const dirClass = (d: string) => (d === 'LONG' ? 'text-up' : 'text-down');
export const titleCase = (s: string) => s.toLowerCase().replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
